import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'primereact/button';
import UserInfo from '../../../shared/UserInfo/UserInfo';
import { ImplementationFor, arraySort } from '../../../shared/utility';
import * as actions from '../../../store/actions/index';
import Messages from '../../../shared/UI/Messages/Messages';
import { Toast } from 'primereact/toast';
import axios from '../../../axios-url';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { DROPDOWN_CONFIG } from '../../../shared/Config';
import Attachments from '../../../shared/UI/Attachments/Attachments'; 
import moment from 'moment';
import UploadImage from '../../../assets/images/uploadImg.svg';
import readXlsxFile from 'read-excel-file';
import { Accordion, AccordionTab } from 'primereact/accordion';
import lodash from 'lodash';
import * as XLSX from 'xlsx';

const Inputs = ({ field, metaData, onInputChange, ...props }) => {

    const Component = ImplementationFor[field.fieldType] || false;
    return Component && <Component
        {...field}
        {...props}
        name={field.fieldName}
        label={field.fieldDescription}
        placeholder={field.fieldDescription}
        onInputChange={onInputChange}
        metaData={metaData}
    /> || null;

}

const TIMEBOOKING_ID = '22fd47a1-5cf6-4450-9dfe-aef9348df6d0';
let AttendanceType = [
    {"label":"IN","value":1,"id":"1"},
    {"label":"OUT","value":2,"id":"2"}]; 

    const TXT_STATUS_TO_ATTENDANCE_TYPE = {
    '1': 1,
    '2': 2,
};


class TimeBooking extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            process: [],
            initialData: {},
            processInitiated: false,
            stageSequence: 0,
            fromDate: false,
            toDate: false,
            requestDate: moment(),
            otType:false,
            DynamicSupervisor: false,
            dynamicSupervisorDisplay: false,
            DynamicSupervisorsList: [],
            employees: false,
            OTHours: false,
            requestId: false,
            popupType: 'submit',
            activeIndex: false,
            requestattachments: [],
            workorderno: '',
            Reason:'',
        }
        this.initialize = this.initialize.bind(this);
        this.readFromExcel = this.readFromExcel.bind(this);
        this.saveRequest = this.saveRequest.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleMethods = this.handleMethods.bind(this);
        this.handleExcel = this.handleExcel.bind(this);

        this.readFromTxt = this.readFromTxt.bind(this);
        this.parseTxtRecords = this.parseTxtRecords.bind(this);
        this.buildProcessFromBookingData = this.buildProcessFromBookingData.bind(this);
    }
    getNextWorkingDate = (otempid) => {
        this.setState({loading:true});
        const { requestedFor, fromDate } = this.state;
        //const reportingDate = moment(toDate).add(1, 'days');
        axios.get(`/master/api/GetTotalOTDone?id=${otempid}`).then(response =>{
            this.setState({loading:false});
            return response.data.OTDone
        }).catch(err => {
            this.growl.show({severity: 'error', summary: null, detail: 'Total OT Hour API Failed'});
            this.setState({loading:false});
        })  
    }

    

    handleChange = (e, el) => {
        e.preventDefault();
        const { name, value,type, checked } = e.target;

        if (el) {
            let selIndex = 0;
            let selEmployees = el.fieldDescription === 'Employees' && value || [];
            const process = this.state.process.filter((p, i) => i <= parseInt(this.state.stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, {
                stage_Field: stage.stage_Field.map(field => {
                    let EmployeeId = null;
                    if (field.fieldDescription === "Employee Id" && el.fieldDescription === 'Employees') {
                        if (parseInt(selIndex) === selEmployees.length) {
                            selIndex = 0;
                        }
                        EmployeeId = selEmployees && selEmployees.length > 0 && selEmployees[selIndex] || null;
                        selIndex++;
                    }
                    return Object.assign({}, { ...field }, { fieldValue: (field.fieldDescription === "Employee Id" && el.fieldDescription === 'Employees') ? EmployeeId :(field.fieldDescription === "OT Type" && el.fieldDescription === 'OT Type') ? value : (type === 'checkbox' && field.fieldName === name) ? checked: (field.fieldDescription === "Employees" && el.fieldDescription === 'Employees') ? value.map(c => c).join(',') : field.fieldName === name ? value : (el.fieldDescription === 'OT Hours' && field.fieldDescription === 'Hours') ? value  : field.fieldValue })
                })
            }));

            this.setState({
                fromDate: el.fieldDescription === "From Date" ? value : this.state.fromDate,
                toDate: el.fieldDescription === "To Date" ? value : this.state.toDate,
                employees: el.fieldDescription === "Employees" ? value.map(c => c).join(',') : this.state.employees,
                OTHours: el.fieldDescription === "OT Hours" ? value : this.state.OTHours,
                requestDate: el.fieldDescription === "Request Date" ? value : this.state.requestDate,
                process,
                otType: el.fieldDescription === "OT Type" ? value : this.state.otType,
                workorderno: el.fieldDescription === "Work Order No." ? value : this.state.workorderno,
                Reason:el.fieldDescription === "Reason" ? value : this.state.Reason,
            });

        }
    }

    initialize = (process, type) => {
        const { tableLists, location = {} } = this.props;
        const { stageSequence, fromDate, toDate, employees, OTHours, requestDate, otType,workorderno,Reason,RequestedFor } = this.state;
        const status = (location.state && location.state.editStatus) || (tableLists && Object.keys(tableLists).length > 0 && tableLists.status) || false;
        const pageType = this.props.match.params.type;
        const pendingWith = location && location.state && location.state.pendingWith 
        const requestFrom = location && location.state && location.state.requestFrom;

        let count = 1;
        let sequence = 1;
        let start = new Date(fromDate);
        let end = new Date(toDate);

        if ((type === 'progress' && fromDate && toDate && employees && start <= end) || type === 'add' || type === 'edit' || type === 'request') {


            this.setState({ process: [], loading: true });
            const InitialValues = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {
                const stageField = arraySort(stage.stage_Field, 'fieldSequence');
                return Object.assign({}, { ...stage }, {
                    stage_Field: stageField.reduce((a, el) => {
                        const startIndex = el.fieldName.substring(0, 10);
                        if ((type === 'add' && stageIndex === 0 && (el.fieldDescription === "From Date" ||el.fieldDescription === "To Date"  || el.fieldDescription === "To Date" || el.fieldDescription === "Employees" )) || (type === 'add' && stageIndex > 0)) {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, fieldValue: el.fieldDescription === "Request Date" && requestDate || el.fieldValue, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            this.setState({processInitiated:false});
                        } else if ((type === 'request' && stageIndex === 0 && (el.fieldDescription === "Requested For" || el.fieldDescription === "From Date" || el.fieldDescription === "To Date")) || (type === 'add' && stageIndex > 0)) {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldValue: (el.fieldDescription === 'Requested For' && RequestedFor) || el.fieldValue, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                        } else if (type === 'progress' && el.fieldType === '9') {
                            const container = stageField.find(_ => _.fieldType === '9');
                            const name = container.fieldName;
                            const fields = stageField.filter(_ => _.parentFieldId === name);

                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));

                            let selEmployees = employees.split(',');
                            if (selEmployees && selEmployees.length > 0) {
                                let loopIndex = 0;

                                selEmployees.map(sel => {
                                    let startDate = new Date(fromDate);
                                    let endDate = new Date(toDate);
                                    if (fromDate && toDate && startDate <= endDate) {
                                        while (startDate <= endDate) {
                                            fields.map((subField) => {
                                                let formatDate = new Date(startDate);
                                                a.push(Object.assign({}, { ...subField },
                                                    {
                                                        childRowNmbr: loopIndex,
                                                        fieldName: `${startIndex}${count++}`,
                                                        fieldSequence: sequence++,
                                                        groupingfieldvalue: sel,
                                                        stageSequence: stageIndex,
                                                        stageNum: `00${stageIndex}`,
                                                        fieldValue: (subField.fieldDescription === 'OT Date' && formatDate) || (subField.fieldDescription === 'Hours' && OTHours) || (subField.fieldDescription === 'Employee Id' && sel) || (subField.fieldDescription === 'OT Type' && otType) || subField.fieldValue
                                                    }));

                                            });
                                            loopIndex++;
                                            startDate.setDate(startDate.getDate() + 1);
                                        }
                                    }

                                });

                            }
                            this.setState({processInitiated:true});

                        } else if (type === 'progress' && el.parentFieldId === '000') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, fieldValue: (el.fieldDescription === "From Date" && fromDate) ||(el.fieldDescription === "Work Order No." && workorderno) ||(el.fieldDescription === "Reason" && Reason) || (el.fieldDescription === "Employees" && employees) || (el.fieldDescription === "OT Hours" && OTHours) || (el.fieldDescription === "To Date" && toDate) || (el.fieldDescription === "Request Date" && requestDate) || (el.fieldDescription === "OT Type" && otType) || el.fieldValue, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            this.setState({processInitiated:true});
                        } else if (type === 'edit') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stage_FieldsList: [], disabled: (requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            if (el.stage_FieldsList && el.stage_FieldsList.length > 0) {
                                el.stage_FieldsList.map((subField, subIndex) => {
                                    if (subIndex != 0) {
                                        subField.stage_FieldsListc2.map(c2 => {
                                            a.push(Object.assign({}, { ...c2 }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, disabled: (requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence && pendingWith !== null ) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                                        })
                                    }
                                })
                            }
                            this.setState({processInitiated:true});
                        } else if(type === "bulkUpload"){
                            
                        }
                        return a;
                    }, [])
                })
            });

            if (InitialValues && InitialValues.length > 0)
                setTimeout(() => this.setState({ loading: false, process: InitialValues }), 3000);

            setTimeout(this.handleExcel.bind(this), 2000);


        } else {
            this.setState({ loading: false });
            this.growl.show({ severity: 'error', summary: null, detail: 'please provide correct details' });
        }
    }
    

    readFromExcel = (vals, process) => {
        const input = document.getElementById('bulkUploadFile');
        if (input){
        const { stageSequence, requestDate, fromDate, toDate, employees, OTHours, otType,workorderno,Reason } = this.state;

        const { keywordValuesList: empList} = this.props;


        let count = 1;
        let sequence = 1;
        
        let empBookingData = [] // contains an arry of obj with each obj having empid empname month of the ot year of the ot and hour for each specific day at "hours" key

        readXlsxFile(input.files[0]).then((BookingData) => {
          //  let otDays = BookingData[0].slice(4)
          //  var monthc = "";
           let InvalidEmployees = []; // Track Invalid employee IDs
                                
                   
                    
            BookingData.forEach((row, rowIndex) => {
                if (rowIndex > 0) { // ignoring the first row since it is the header
                     // Validate if employee ID exists in empList
                    const employeeExists = empList.find(emp => emp.id === parseInt(row[0]));
                    if (!employeeExists) {
                        InvalidEmployees.push(row[0]);
                        return; // Skip this row and continue with next
                    }
                    BookingData = {}
                    if (row[3] != null && row[3] != undefined) {
                        let a = row[3].match(/\d+/g)
                        if (a.length > 0) {
                            if (!isNaN(a[0])) {
                                var valAsString = a[0].toString(10);
                                if (valAsString.length === 1) {
                                    a[0] = "0" + a[0];
                                }
                            }
                            if (a.length > 1) {
                                if (!isNaN(a[1])) {
                                    var valAsString1 = a[1].toString(10);
                                    if (valAsString1.length === 1) {
                                        a[1] = "0" + a[1];
                                    }
                                }
                                row[3] = a[0] + ":" + a[1]  + ":00";
                            }
                            else {
                                row[3] = a[0] +  ":00" + +":00";
                            }
                        }
                        else {
                            row[3] = "00" + ":00"  +":00";
                        }
                    
                        //     let otHours = row.slice(4) // need to develop more on this
                        BookingData.empId = employeeExists.value
                        BookingData.empName = row[1]
                        BookingData.Date = row[2]
                        BookingData.Time = row[2].substr(0, 10) + ": " + row[3].substr(0, 5) + ":00"
                        BookingData.AttendanceType = 1
                        BookingData.Reason = row[5]
                        empBookingData.push(BookingData)
                        //      monthc = BookingData.month = row[2]
                    }

                    if (row[4] != null && row[4] != undefined) {
                        let b = row[4].match(/\d+/g)
                        if (b.length > 0) {
                            if (!isNaN(b[0])) {
                                var valAsStringb = b[0].toString(10);
                                if (valAsStringb.length === 1) {
                                    b[0] = "0" + b[0];
                                }
                            }
                            if (b.length > 1) {
                                if (!isNaN(b[1])) {
                                    var valAsString1b = b[1].toString(10);
                                    if (valAsString1b.length === 1) {
                                        b[1] = "0" + b[1];
                                    }
                                }
                                row[4] = b[0] + ":" + b[1]  + ":00";
                            }
                            else {
                                row[4] = b[0] +  ":00" + +":00";
                            }
                        }
                        else {
                            row[4] = "00" + ":00"  +":00";
                        }
                    let BookingData2 = {}
                        //     let otHours = row.slice(4) // need to develop more on this
                        BookingData2.empId = employeeExists.value
                        BookingData2.empName = row[1]
                        BookingData2.Date = row[2]
                        BookingData2.Time = row[2].substr(0, 10) + ": " + row[4].substr(0, 5) + ":00"
                        BookingData2.AttendanceType = 2
                        BookingData2.Reason = row[5]
                        empBookingData.push(BookingData2)
                        //      monthc = BookingData.month = row[2]
                    }
                }
            })

            // Show warning for invalid employees
            if (InvalidEmployees.length > 0) {
                this.growl.show({
                    severity: 'warn',
                    summary: null,
                    detail: `Warning: The following employee IDs are not found in employee master list: ${[...new Set(InvalidEmployees)].join(', ')}`
                });
            }



        if (empBookingData) {
            this.setState({ process: [], loading: true });
            const InitialValues = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {
                const stageField = arraySort(stage.stage_Field, 'fieldSequence');
                return Object.assign({}, { ...stage }, {
                    stage_Field: stageField.reduce((a, el) => {
                        const startIndex = el.fieldName.substring(0, 10);
                        if (el.fieldType === '9') {
                            const container = stageField.find(_ => _.fieldType === '9');
                            const name = container.fieldName;
                            const fields = stageField.filter(_ => _.parentFieldId === name);

                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));

                            let selEmployees = empBookingData;
                            if (selEmployees && selEmployees.length > 0) {
                                let loopIndex = 0;

                                selEmployees.forEach(sel => {
                                    var { empId, Date, Time, AttendanceType,Reason } = sel
                                   // monthc = month;

                                        fields.map((subField) => {

                                            
                                        //    let formatDate = new Date(Date).toISOString();


                                          
                                            a.push(Object.assign({}, { ...subField },
                                                {
                                                    childRowNmbr: loopIndex,
                                                    fieldName: `${startIndex}${count++}`,
                                                    fieldSequence: sequence++,
                                                    groupingfieldvalue: sel.empId,
                                                    stageSequence: stageIndex,
                                                    stageNum: `00${stageIndex}`,
                                                    fieldValue: (subField.fieldDescription === 'Date' && Date) || (subField.fieldDescription === 'Date & Time' && Time) || (subField.fieldDescription === 'Attendance Type' && AttendanceType) ||(subField.fieldDescription === 'Reason' && Reason) || (subField.fieldDescription === 'Employee Id' && empId) || subField.fieldValue
                                                }));

                                        });
                                        loopIndex++;

                                });

                            }
                            this.setState({processInitiated:true});

                        }else if (el.parentFieldId === '000') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, fieldValue: (el.fieldDescription === "Employees" && employees) || (el.fieldDescription === "Request Date" && requestDate) || el.fieldValue, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            this.setState({processInitiated:true});
                        } 
                        return a;
                    }, [])
                })
            });

            if (InitialValues && InitialValues.length > 0)
                setTimeout(() => this.setState({ loading: false, process: InitialValues }), 2000);

            setTimeout(this.readFromExcel.bind(this), 3000);


        } else {
            this.setState({ loading: false });
            this.growl.show({ severity: 'error', summary: null, detail: 'please provide correct details' });
        }

        })

    }


    }



    handleExcel = () => {
        const input = document.getElementById('file-8');
        if (input) {
            input.addEventListener('change', () => {
                this.setState({ loading: true });
                const { keywordValuesList: empList} = this.props;
                const { initialData, stageSequence, requestDate } = this.state;

                let count = 1;
                let sequence = 1;
                let EmployeeList = [];
                let FromDate = false;
                let ToDate = false;

                const process = initialData.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {
                    const stageField = arraySort(stage.stage_Field, 'fieldSequence');
                    return Object.assign({}, { ...stage }, {
                        stage_Field: stageField.reduce((a, el) => {
                            const startIndex = el.fieldName.substring(0, el.fieldName.length - 1);
                            if (el.fieldType === '9') {
                                const container = stageField.find(_ => _.fieldType === '9');
                                const name = container.fieldName;
                                const fields = stageField.filter(_ => _.parentFieldId === name);

                                a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));


                                readXlsxFile(input.files[0]).then((rows) => {
                                    let loopIndex = 0;
                                    rows.map((row, rowIndex) => {
                                        let selEmployee = rows[0]
                                        let month = rows[2]
                                        let year = rows[3]
                                        if (rowIndex > 0) {
                                            row.map((el, i) => {
                                                if (i > 3 && selEmployee && month && year ) {
                                                    let formatDate = new Date(moment(`${month}, ${rows[0][i]} ${year}`));
                                                    let OTHours = (el === null || el === 'null') ? '0' : el.toString();
                                                    FromDate = (i === 4 && rowIndex === 1) && formatDate || FromDate;
                                                    ToDate = (i === (row.length - 1) && rowIndex === 1) && formatDate || ToDate;

                                                    const emps = fields.map((subField) => ({
                                                                childRowNmbr: loopIndex,
                                                                fieldName: `${startIndex}${count++}`,
                                                                fieldSequence: sequence++,
                                                                groupingfieldvalue: selEmployee.value,
                                                                fieldValue: (subField.fieldDescription === 'OT Date' && formatDate) || (subField.fieldDescription === 'Hours' && OTHours) || (subField.fieldDescription === 'Employee Id' && selEmployee && selEmployee.value) || subField.fieldValue,
                                                                stageSequence: stageIndex, 
                                                                stageNum: `00${stageIndex}`
                                                            }))


                                                    
                                                    EmployeeList.push(selEmployee);
                                                    fields.map((subField) => {
                                                        a.push(Object.assign({}, { ...subField },
                                                            {
                                                                childRowNmbr: loopIndex,
                                                                fieldName: `${startIndex}${count++}`,
                                                                fieldSequence: sequence++,
                                                                groupingfieldvalue: selEmployee.value,
                                                                fieldValue: (subField.fieldDescription === 'OT Date' && formatDate) || (subField.fieldDescription === 'Hours' && OTHours) || (subField.fieldDescription === 'Employee Id' && selEmployee && selEmployee.value) || subField.fieldValue,
                                                                stageSequence: stageIndex, 
                                                                stageNum: `00${stageIndex}`
                                                            }));

                                                    });
                                                    loopIndex++;
                                                }

                                            })

                                            
                                        }
                                    })
                                })


                            } else if (el.parentFieldId === '000') {
                                a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, fieldValue: el.fieldDescription === 'Request Date' && requestDate || el.fieldValue, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            }
                            return a;
                        }, [])
                    })
                });


                if (process && process.length > 0)
                    setTimeout(() => {
                        this.setState({ loading: false, process, employees: EmployeeList && Array.isArray(EmployeeList) && EmployeeList.length > 0 ? [...new Set(EmployeeList.map(e => e.value))].join(',') : [], fromDate: FromDate, toDate: ToDate })
                    }, 1000);

            })
        }

    }

    handleAttachment = (data, type) => {
        let index = 0;
        let attachmentData = data.map((el) => {
            index++
            return{
                Requestattachmentid: '00000000-0000-0000-0000-000000000000' ,
                Requestid :'00000000-0000-0000-0000-000000000000',
                SiNo: index ,
                UploadPath:el.filePath ,
                FileName:el.fileName ,
                Extension :el.fileExtension,
                Createdby: this.props.loggedUserDetail.empID ,
                Createddate: moment().format('MM/DD/YYYY') ,
                Updatedby: this.props.loggedUserDetail.empID ,
                Updateddate: moment().format('MM/DD/YYYY') ,
                CompanyId: this.props.loggedUserDetail.CompanyId ,
                Stagenum: 0 ,
            }
        });
        this.setState({requestattachments:attachmentData});
    }

    saveRequest = (submitType) => {
        const { containerData } = this.props;
        const { process, fromDate, toDate, employees, processInitiated,workorderno,Reason } = this.state;
        const type = this.props.match.params.type;

        if(!processInitiated){
            this.growl.show({ severity: 'error', summary: null, detail: 'Please Initiate before Submitting/Saving' });
            this.setState({ loading: false })
            return;
        }

        let FromDate = fromDate;
        let ToDate = toDate;
        let Workordernum = workorderno;
        let reason = Reason;
        let RequestDate = new Date();
        let Comment = '';
        let RequestAttributes = [];
        process.map((stage, stageIndex) => {
            stage.stage_Field.map(el => {
                if (el.fieldDescription === 'From Date') {
                    el.fieldValue = fromDate || el.fieldValue;
                    FromDate = el.fieldValue || FromDate; 
                } else if (el.fieldDescription === 'To Date') {
                    el.fieldValue = toDate || el.fieldValue;
                    ToDate = el.fieldValue || ToDate;
                } else if (el.fieldDescription === 'Employees') {
                    el.fieldValue = employees || el.fieldValue;
                } else if (el.fieldDescription === 'Request Date' && el.fieldValue) {
                    RequestDate = el.fieldValue;
                } else if (el.fieldDescription === 'Comment' && stageIndex === 0) {
                    Comment = el.fieldValue;
                }else if (el.fieldDescription === 'Work Order No.') {
                    el.fieldValue = workorderno || el.fieldValue;
                    Workordernum = el.fieldValue || Workordernum;
                }else if (el.fieldDescription === 'Reason') {
                    el.fieldValue = toDate || el.fieldValue;
                    reason = el.fieldValue || reason;
                }
                
                RequestAttributes.push(Object.assign({}, {...el}, {fieldValue: (el.fieldType === "7" || el.fieldType === "8" || (el.fieldType === "1" && el.fieldStatus === "Display Only")) ? moment(el.fieldValue).format('MM/DD/YYYY') : el.fieldValue}));
            })
        });



        let data = {
            FromDate: moment().format('MM/DD/YYYY'),
            ToDate: moment().format('MM/DD/YYYY'),
            VisaCount: 0,
            TicketCount: 0,
            RequestDesc: 'TimeBooking Request',
            IsActive: true,
            RequestDate: RequestDate && moment(RequestDate),
            EmpID: this.props.loggedUserDetail.empID,
            LoginEmployeeID: this.props.loggedUserDetail.empID,
            CompanyID: this.props.loggedUserDetail.CompanyId,
            Remark: Comment,
            RequestedFor: this.props.loggedUserDetail.empID,
            ProcessID: TIMEBOOKING_ID,
            RequestAttributes: RequestAttributes,
            Requestattachments: this.state.requestattachments,
            Requestforms: [],
            Requestactions: [],
            stagesequence: this.state.stageSequence,
            processNum: containerData.processNum
        };


        if (process && process.length > 0) {

            let model = 'requestSave';
            if (submitType === 'submit') {
                if (this.state.DynamicSupervisor) {
                    data.DynamicSupervisor = this.state.DynamicSupervisor;
                }

                model = 'TimeBooking';
            }

            if (submitType === 'delegate') {
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Delegate_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                model = 'TimeBooking';
            }

            if (submitType === 'forward') {
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Forward_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                model = 'TimeBooking';
            }

            if (submitType === 'return' && this.state.DynamicSupervisor) {
                const SelDropdownEmployee = this.state.DynamicSupervisorsList.find(el => el.value === this.state.DynamicSupervisor);
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Return_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                data.Return_to_WF_Level_ID = SelDropdownEmployee && Object.keys(SelDropdownEmployee).length > 0 && SelDropdownEmployee.Request_WF_LEVEL_ID;
                model = 'TimeBooking';
            }
            

            if (submitType === 'cancel') {
                model = 'TimeBooking';
            }

            if (this.state.requestId) {
                data.requestId = this.state.requestId
            }

            
            var stringifyData = JSON.stringify(data);
            var datas = { Key: stringifyData };

            let url = (type === 'edit') ? '/master/api/UpdateDynamicData?model=' + model : '/master/api/InsertDynamicData?model=' + model;

            if (submitType === 'submit') {
                url = '/master/api/workflow/submit?type=' + model;
            } else if (submitType === 'reject') {
                url = '/master/api/workflow/reject?type=' + model;
            } else if (submitType === 'delegate') {
                url = '/master/api/workflow/delegate?type=' + model;
            } else if (submitType === 'forward') {
                url = '/master/api/workflow/forward?type=' + model;
            } else if (submitType === 'return') {
                url = '/master/api/workflow/return?type=' + model;
            } else if (submitType === 'cancel') {
                url = '/master/api/workflow/cancel?type=' + model;
            }

            this.setState({ loading: true });
            
            axios.post(url, JSON.stringify(datas))
                .then(response => {
                    this.setState({ loading: false });
                    if (submitType === 'submit' || submitType === 'return') {
                        if (response.status === 200) {
                            if (response.data.id !== undefined && response.data.id === 'DYNAMIC') {
                                let submitValue = response.data.result && JSON.parse(response.data.result);
                                let tableValue = [];
                                if (submitValue.Table !== undefined && submitValue.Table.length > 0) {
                                    tableValue = submitValue.Table.map(list => {
                                        return { label: list.NAME, value: list.EMPLOYEE_ID, id: list.EMPLOYEE_NO, Request_WF_LEVEL_ID: list.Request_WF_LEVEL_ID }
                                    })
                                }

                                if(submitType === 'return'){
                                    this.setState({popupType: 'return'});
                                }
                                this.setState({ requestId: response.data.requestId, dynamicSupervisorDisplay: true, DynamicSupervisorsList: tableValue })
                            } else {
                                this.growl.show({ severity: 'success', summary: null, detail: 'TimeBooking request submitted successfully' });
                                this.props.history.push('/dashboard');
                            }
                        } else {
                            this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
                        }

                    } else {
                        this.growl.show({ severity: 'success', summary: null, detail: 'TimeBooking request saved successfully' });
                        this.props.history.push('/dashboard');
                    }

                })
                .catch(err => {
                    this.setState({ loading: false })
                    this.growl.show({ severity: 'error', summary: null, detail: err && err.response && err.response.data || 'Submit Failed' });
                })

        }

    }

    // Shared builder used only by the new TXT upload path — mirrors the tail end of
    // readFromExcel's own process-building logic, kept separate so readFromExcel
    // itself doesn't need to change.
    buildProcessFromBookingData = (empBookingData, process) => {
        const { stageSequence, requestDate, employees } = this.state;

        let count = 1;
        let sequence = 1;

        if (empBookingData && empBookingData.length > 0) {
            this.setState({ process: [], loading: true });
            const InitialValues = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {
                const stageField = arraySort(stage.stage_Field, 'fieldSequence');
                return Object.assign({}, { ...stage }, {
                    stage_Field: stageField.reduce((a, el) => {
                        const startIndex = el.fieldName.substring(0, 10);
                        if (el.fieldType === '9') {
                            const container = stageField.find(_ => _.fieldType === '9');
                            const name = container.fieldName;
                            const fields = stageField.filter(_ => _.parentFieldId === name);

                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));

                            let selEmployees = empBookingData;
                            if (selEmployees && selEmployees.length > 0) {
                                let loopIndex = 0;

                                selEmployees.forEach(sel => {
                                    var { empId, Date, Time, AttendanceType, Reason } = sel;

                                    fields.map((subField) => {
                                        a.push(Object.assign({}, { ...subField },
                                            {
                                                childRowNmbr: loopIndex,
                                                fieldName: `${startIndex}${count++}`,
                                                fieldSequence: sequence++,
                                                groupingfieldvalue: sel.empId,
                                                stageSequence: stageIndex,
                                                stageNum: `00${stageIndex}`,
                                                fieldValue: (subField.fieldDescription === 'Date' && Date) || (subField.fieldDescription === 'Date & Time' && Time) || (subField.fieldDescription === 'Attendance Type' && AttendanceType) || (subField.fieldDescription === 'Reason' && Reason) || (subField.fieldDescription === 'Employee Id' && empId) || subField.fieldValue
                                            }));
                                    });
                                    loopIndex++;
                                });
                            }
                            this.setState({ processInitiated: true });

                        } else if (el.parentFieldId === '000') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, fieldValue: (el.fieldDescription === "Employees" && employees) || (el.fieldDescription === "Request Date" && requestDate) || el.fieldValue, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            this.setState({ processInitiated: true });
                        }
                        return a;
                    }, [])
                })
            });

            if (InitialValues && InitialValues.length > 0)
                setTimeout(() => this.setState({ loading: false, process: InitialValues }), 2000);

        } else {
            this.setState({ loading: false });
            this.growl.show({ severity: 'error', summary: null, detail: 'please provide correct details' });
        }
    }

    // Parses the raw device punch-log text, e.g.:
    // Return(result="success" dev_id="..." total="139"
    // time="2026-07-21 17:58:17" id="9811893" name="" workcode="0" status="1" authority="0X11" card_src="from_check"
    // time="2026-07-21 17:58:21" id="9812321" name="" workcode="0" status="1" authority="0X11" card_src="from_check"
    // ...)
    // Every record begins with a "time" key, so we use that as the record boundary.
    parseTxtRecords = (text) => {
        const records = [];
        const pairRegex = /(\w+)="([^"]*)"/g;
        let match;
        let current = null;

        while ((match = pairRegex.exec(text)) !== null) {
            const [, key, value] = match;
            if (key === 'time') {
                if (current) records.push(current);
                current = {};
            }
            if (current) {
                current[key] = value;
            }
            // Anything before the first "time" key (result, dev_id, total) is header
            // info and is intentionally skipped here.
        }
        if (current) records.push(current);

        return records;
    }

    readFromTxt = (file, process) => {
        if (!file) return;

        const { keywordValuesList: empList } = this.props;
        const reader = new FileReader();

        reader.onload = (e) => {
            const text = e.target.result;
            const records = this.parseTxtRecords(text);

            let empBookingData = [];
            let InvalidEmployees = [];
            let InvalidStatusCount = 0;

            records.forEach((rec) => {
                const empId = parseInt(rec.id, 10);
                const employeeExists = empList.find(emp => emp.id === empId);
                if (!employeeExists) {
                    InvalidEmployees.push(rec.id);
                    return;
                }

                const attendanceType = TXT_STATUS_TO_ATTENDANCE_TYPE[rec.status];
                if (!attendanceType) {
                    InvalidStatusCount++;
                    return; // unrecognized status code, skip the punch
                }

                const [datePart, timePart] = (rec.time || '').split(' ');

                empBookingData.push({
                    empId: employeeExists.value,
                    empName: employeeExists.label,
                    Date: datePart || '',
                    Time: `${datePart || ''}: ${(timePart || '00:00:00')}`,
                    AttendanceType: attendanceType,
                    Reason: '',
                });
            });

            if (InvalidEmployees.length > 0) {
                this.growl.show({
                    severity: 'warn',
                    summary: null,
                    detail: `Warning: The following employee IDs are not found in employee master list: ${[...new Set(InvalidEmployees)].join(', ')}`
                });
            }

            if (InvalidStatusCount > 0) {
                this.growl.show({
                    severity: 'warn',
                    summary: null,
                    detail: `Warning: ${InvalidStatusCount} record(s) had an unrecognized status code and were skipped.`
                });
            }

            this.buildProcessFromBookingData(empBookingData, process);
        };

        reader.onerror = () => {
            this.growl.show({ severity: 'error', summary: null, detail: 'Failed to read the TXT file' });
        };

        reader.readAsText(file);
    }

    componentDidMount() {
        const { getContainerData, getMasterKeywordList, getKeywordValues, fetchSubordinatesLists, loggedUserDetail, location = {} } = this.props;
        const type = this.props.match.params.type;
        this.setState({processInitiated:false})
        getContainerData(TIMEBOOKING_ID);//Get Container Data
        getMasterKeywordList('Shift');// Get Shift Dropdown list
        getKeywordValues('Employee');//Get Employee Dropdown list
        getMasterKeywordList('OTType');//Get Employee Dropdown list
        if (type != 'edit') {
            fetchSubordinatesLists(loggedUserDetail.empID, loggedUserDetail.CompanyId);//Fetch subordinate api list
        }

        if (type === 'edit') {
            this.props.getRequestAttributeData(this.props.match.params.id);
        }

        const clearTimer = () => clearInterval(interval);
        const interval = setInterval(() => {
            const stageSequence = (location.state && location.state.stagesequence) || this.state.stageSequence;
            const requestId = this.props.match.params.id || this.state.requestId;
            const { tableLists = {}, containerData } = this.props;
            const { employeeID, companyID } = tableLists;
            const type = this.props.match.params.type;
            let requestattachments = tableLists.requestattachments || [];
            this.setState({requestattachments});

            const container = containerData && Object.keys(containerData).length > 0 && containerData.stage || [];
            let process = containerData && Object.keys(containerData).length > 0 && containerData.stage || [];
            if (type === 'edit') {
                process = tableLists && Object.keys(tableLists).length > 0 && tableLists.requestAttribute1 || [];
            }

            if (process && process.length > 0 && !this.props.loading) {
                this.setState({ stageSequence, requestId, initialData: type === 'edit' && process.concat(container.filter(((c, i) => i > (process.length-1)))) || process });
                setTimeout(() => this.initialize(type === 'edit' && process.concat(container.filter(((c, i) => i > (process.length-1)))) || process, type === 'edit' ? 'edit' : 'add'), 3000);
                
                if (employeeID && companyID)
                    fetchSubordinatesLists(employeeID, companyID);//Fetch subordinate api list
                
                clearTimer();
            }
        }, 300);


    }

    handleMethods(type) {
        this.setState({ popupType: type });
        const { keywordValuesList } = this.props;
        this.setState({ dynamicSupervisorDisplay: true, DynamicSupervisorsList: keywordValuesList })
    }

    componentWillUnmount() {
        const { clearCacheStorage } = this.props;
        clearCacheStorage('request', { containerData: {}, requestAttributeData: {}, keywordValuesList: [], subordinatesListData: [] })
    }

    handleTabChange(e) {
        this.setState({ loading: true, activeIndex: e.index })
        setTimeout(() => this.setState({ loading: false }), 3000);
    }

    downloadOtTemplate = () => {
        const process = this.state.process;
        const stage_Field = process[0].stage_Field;
    
        const Fromdate = stage_Field.find(field => field.fieldId === "50be810e-061a-41db-b307-478a389fcac8");
        const Todate = stage_Field.find(field => field.fieldId === "50be810e-061a-41db-b307-478a389fcac9");
    
        const fromDate = Fromdate.fieldValue ? new Date(Fromdate.fieldValue) : null;
        const toDate = Todate.fieldValue ? new Date(Todate.fieldValue) : null;
    
        const employees = stage_Field.find(field => field.fieldId === "50be810e-061a-41db-b307-478a389fcac7");
    
        let missingFields = [];
        if (!fromDate) missingFields.push('From Date');
        if (!toDate) missingFields.push('To Date');
        if (!employees.fieldValue) missingFields.push('Employees');
    
        if (missingFields.length > 0) {
            this.growl.show({
                severity: 'error',
                summary: null,
                detail: `The following fields are missing: ${missingFields.join(', ')}.`
            });
            return;
        }
    
        const employeeList = employees.fieldValue.split(',');
    
        const propsEmployee = this.props.metaData.Employees;
    
        const employeeObject = {};
        employeeList.forEach((value, index) => {
            employeeObject[index] = value;
        });
    
        const employeesArray = [];
        Object.values(employeeObject).forEach(employeeValue => {
            propsEmployee.forEach(employee => {
                if (employee.value === employeeValue) {
                    employeesArray.push([employee.label, employee.id]);
                }
            });
        });
    
        // Define the columns for the Excel file
        const columns = ['Employee ID', 'Employee Name', 'Date', 'Time In', 'Time Out', 'Reason'];
    
        const rows = [];
    
        // Generate rows for each employee and each date between fromDate and toDate
        employeesArray.forEach(employee => {
            let currentDate = new Date(fromDate);
            while (currentDate <= toDate) {
                rows.push([
                    employee[1], // Employee ID
                    employee[0], // Employee Name
                    currentDate.toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric'
                      }).replace(/\//g, '-'), // Date in dd/mm/yyyy format
                    '', // Leave Time column empty for manual entry
                    '', // Attendance (empty)
                    ''  // Reason (empty)
                ]);
                currentDate.setDate(currentDate.getDate() + 1);
            }
        });
    
        // Combine header and data
        const sheetData = [columns, ...rows];
    
        // Create a worksheet
        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
    
        // Force the 'Time' column cells to be text
        Object.keys(worksheet).forEach(cell => {
            if ((cell.startsWith('D') && cell !== 'D1') || cell.startsWith('E') && cell !== 'E1') { // 'D' column except the header
                worksheet[cell].z = '@'; // Excel format for Text
                worksheet[cell].t = 's'; // Set cell type to string
            }
        });
    
        // Create a workbook and export
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "TimeBooking Template");
    
        XLSX.writeFile(workbook, 'TimeBooking_Template.xlsx');
    };
    
    
    
    
    

    render() {
        const { tableLists, subordinatesListData = [], location = {}, keywordValuesList: empList = [] } = this.props;
        const { state = {} } = location;
        const { fromDate, toDate, process, stageSequence, employees,Reason,workorderno } = this.state; 
        const status = (location.state && location.state.editStatus) || (tableLists && Object.keys(tableLists).length > 0 && tableLists.status) || false;
        const pageType = this.props.match.params.type;
        const pendingWith = location && location.state && location.state.pendingWith 
        const requestFrom = location && location.state && location.state.requestFrom;

        const dialogDynamicFooter = (
            <div>
                <Button icon="pi pi-times" onClick={() => this.setState({ dynamicSupervisorDisplay: false, DynamicSupervisor: null, DynamicSupervisorsList: null })} label="Close" className="p-button-secondary" />
                <Button onClick={() => this.saveRequest(this.state.popupType || 'submit')} icon="pi pi-check" disabled={(this.state.DynamicSupervisor === null)} label="Submit" className="p-button-primary  ml1" />
            </div>
        );

        return (
            <div className="p-grid leaverequest">
                {(this.props.loading || this.state.loading) && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>
                            TimeBooking
                            <Link to={'/TimeBooking'}>
                                <Button style={{ float: 'right' }} label="Back" icon="pi pi-arrow-left" className="ml1 p-button-secondary" />
                            </Link>
                        </h1>
                        <UserInfo userObject={this.props.userPosInfo} requestNum={state.requestNum} />
                    </div>
                </div>

                {process.filter((p, i) => i <= parseInt(stageSequence)).map((stage, stageIndex) => {
                    const { stage_Field = [], description } = stage;
                    const stageField = arraySort(stage_Field, 'fieldSequence');
                    const containers = lodash.mapValues(lodash.groupBy(stageField.filter(_ => _.parentFieldId != '000'), 'groupingfieldvalue'));
                    return <div key={stageIndex} className="p-col-12">
                        <div className="card card-w-title">
                            <h1>{description}</h1>
                            <div className="p-grid">
                                {stageIndex === 0 ? 
                                <div className="p-col-12">
                                    <div className="p-col-12">
                                        <input type="file" name="employeesAttachment" id="bulkUploadFile" className="inputfile inputfile-6 " accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"  onChange={(e) => {
                                        const file = e.target.files[0];
                                        this.readFromExcel(file, this.state.initialData);
                                        }}/>
                                        <label htmlFor="bulkUploadFile"><span></span> <strong><img src={UploadImage} alt="upload im" /> Upload TimeBooking File&hellip;</strong></label>                         
                                    </div>
                                    <div className="p-col-12">
                                    <input type="file" name="employeesTxtAttachment" id="bulkUploadTxtFile" className="inputfile inputfile-6 " accept=".txt,text/plain" onChange={(e) => {
                                    const file = e.target.files[0];
                                     this.readFromTxt(file, this.state.initialData);
                                     e.target.value = null; // allow re-selecting the same file later
                                      }}/>
                                         <label htmlFor="bulkUploadTxtFile"><span></span> <strong><img src={UploadImage} alt="upload im" /> Upload TimeBooking Device Log (TXT)&hellip;</strong></label>
                                     </div>

                                    <div className="p-col-3">
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.downloadOtTemplate()} label="Download Time Booking Template" icon="pi pi-download" />
                                    </div> 
                                </div> : null}
                                {stageField.filter(_ => _.parentFieldId === '000').map((field, fieldIndex) => {
                                    return <div key={fieldIndex} className={field.fieldType === "9" || field.fieldType === "6" ? "p-col-12" : field.fieldDescription === "OT Hours" ? "p-col-12 p-md-8 p-lg-8" : "p-col-12 p-md-6 p-lg-4"}>
                                        {field.fieldDescription === "OT Hours" ? <div className="p-grid">
                                            <div className="p-col-12 p-md-6 p-lg-6">
                                                <Inputs
                                                    field={field}
                                                    value={field.fieldValue}
                                                    process={process}
                                                    onInputChange={(e) => this.handleChange(e, field)}
                                                    {...this.props}
                                                    {...this.state} />
                                            </div>
                                            <div className="noLableMargin p-col-12 p-md-6 p-lg-6" style={{ marginTop: '2.9em' }}>
                                                <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={ () => this.initialize(this.state.initialData, 'progress')} label="Initiate Process" icon="pi pi-upload" />
                                                <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null ) ? true : false} onClick={() => this.initialize(this.state.initialData, 'add')} className="ml1 p-button-info" label="Reset" icon="pi pi-refresh" />
                                            </div>
                                        </div> : <Inputs
                                                field={field}
                                                value={(field.fieldDescription === "Employees" && field.fieldValue && field.fieldValue.split(',')) || (field.fieldDescription === "Employees" && employees && employees.length > 0 && employees.split(',')) || field.fieldDescription === 'From Date' && !field.fieldValue && fromDate || field.fieldDescription === 'To Date' && !field.fieldValue && toDate || field.fieldDescription === 'Work Order No.' && !field.fieldValue && workorderno|| field.fieldDescription === 'Reason' && !field.fieldValue && Reason || field.fieldValue}
                                                process={process}
                                                onInputChange={(e) => this.handleChange(e, field)}
                                                {...this.props}
                                                {...this.state} />}
                                    </div>

                                })}

                                {this.state.processInitiated && 
                                <Accordion activeIndex={this.state.activeIndex} onTabChange={this.handleTabChange.bind(this)}>
                                    {Object.keys(containers).map((emp, empIndex) => {
                                        const EmployeeField = containers[emp];
                                        const selEmployeeDet = empList.find(_ => _.value === emp) || {};
                                       // const totalHours = EmployeeField.reduce((a, el) => el.fieldDescription === 'Hours' && el.fieldValue ? a + parseInt(el.fieldValue) : a, 0);
                                        const Accemp = EmployeeField.reduce((a, el) => el.fieldDescription === 'Employee Id' && el.fieldValue ? el.fieldValue: a, '');
                                        //const usedhour = this.fusedhour(emp);
                                        return <AccordionTab key={empIndex} header={`${selEmployeeDet.label}`}>
                                            <div className="p-grid">
                                                {EmployeeField.map((field, fieldIndex) => {
                                                    return <div key={fieldIndex} className={"p-col-12 p-md-4 p-lg-3"}>
                                                        <Inputs
                                                            field={field}
                                                            value={field.fieldDescription === "Employees" && field.fieldValue && field.fieldValue.split(',') || field.fieldValue}
                                                            process={process}
                                                            onInputChange={(e) => this.handleChange(e, field)}
                                                            {...this.props}
                                                            {...this.state} />
                                                    </div>
                                                })}
                                            </div>
                                        </AccordionTab>
                                    })}
                                </Accordion>}

                                {( stage.stageNum == '000' || stage.stageSequence == 0)  ? 
                                <div className="p-col-12 p-md-12 p-lg-12">
                                     <Attachments 
                                     handleAttachment = {this.handleAttachment} 
                                     folderName = 'TimeBooking'
                                     reloadedValues = {this.state.requestattachments}
                                     isReloaded = {(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false}
                                     /> 
                                </div> 
                                    :
                                 null}

                                {stageIndex > 0 ?
                                    <div className="p-col-12 p-md-12 p-lg-12" >
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) != stageIndex && pendingWith !== null) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('submit')} className="p-button-success ml1" label="Approve" icon="pi pi-save" />
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) != stageIndex && pendingWith !== null) || (status && status === 'Closed'&& pendingWith !== null) ? true : false} label="Reject" onClick={() => this.saveRequest('reject')} className="p-button-danger ml1" />
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) != stageIndex&& pendingWith !== null) || (status && status === 'Closed'&& pendingWith !== null) ? true : false} label="Return" onClick={() => this.saveRequest('return')} className="p-button-warning ml1" />
                                        {/* <Button disabled={(pageType === 'edit' && parseInt(stageSequence) != stageIndex&& pendingWith !== null) || (status && status === 'Closed'&& pendingWith !== null) ? true : false} label="Forward" onClick={() => this.handleMethods('forward')} className="ml1" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) != stageIndex&& pendingWith !== null) || (status && status === 'Closed'&& pendingWith !== null) ? true : false} label="Delegate" onClick={() => this.handleMethods('delegate')} className="p-button-info ml1" /> */}
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence&& pendingWith !== null) != stageIndex) || (status && status === 'Closed'&& pendingWith !== null) ? true : false} onClick={() => this.saveRequest('save')} className="p-button-secondary ml1" label="Save" icon="pi pi-save" />
                                        <Link to={'/TimeBooking'}>
                                            <Button className="p-button-secondary ml1" label="Close" icon="pi pi-times" />
                                        </Link>
                                    </div> :
                                    <div className="p-col-12 p-md-12 p-lg-12" >
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0&& pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed'&& pendingWith !== null) ? true : false} onClick={() => this.saveRequest('save')} className="p-button-secondary ml1" label="Save" icon="pi pi-save" />
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0&& pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed'&& pendingWith !== null) ? true : false} onClick={() => this.saveRequest('submit')} className="p-button-success ml1" label="Submit" icon="pi pi-save" />
                                        <Button disabled={status && status === 'Closed' && pendingWith !== null ? false : true} className="p-button-danger ml1" label="Cancel" style={{ marginRight: '10px' }} onClick={() => this.saveRequest('cancel')} />
                                        <Link to={'/TimeBooking'}>
                                            <Button className="p-button-secondary ml1" label="Close" icon="pi pi-times" />
                                        </Link>
                                    </div>}

                            </div>
                        </div>
                    </div>
                })}


                <Dialog header="Select Supervisor" visible={this.state.dynamicSupervisorDisplay} modal={true} width="400px" footer={dialogDynamicFooter} onHide={() => this.setState({ dynamicSupervisorDisplay: false })}>
                    <div className="p-grid">
                        <div className="p-col-12 p-lg-12">
                            <label className="label">Select Supervisor<span className="requiredColor">*</span></label>
                            <div className="mt1">
                                <Dropdown placeholder="Select Supervisor" name="DynamicSupervisor" value={this.state.DynamicSupervisor} options={this.state.DynamicSupervisorsList} onChange={(e) => this.setState({ DynamicSupervisor: e.target.value })}   {...DROPDOWN_CONFIG} style={{ width: '100%' }} />
                            </div>
                        </div>
                    </div>
                </Dialog>

            </div>

        );
    }
}

const mapStateToProps = (state, props) => {

    const pageType = props.match.params.type;
    const emplist = state?.master?.keywordValuesList?.map(e => ({...e, value:e.uniqueId})) || []
    const subordinatesList = pageType === 'edit' && state.master.requestAttributeData  ? ([Object.assign({}, { label: `${state.master.requestAttributeData.employeename} (Self)`, value: state.master.requestAttributeData.employeeID })]).concat(state.master.subordinatesListData) : ([Object.assign({}, { label: `${state.auth.userObject.userName} (Self)`, value: state.auth.userObject.empID, userId: state.auth.userObject.userID })]).concat(state.master.subordinatesListData);
    const keywordValuesList = state.master.keywordValuesList.reduce((a, el) => {
        if (el.uniqueId !== state.auth.userObject.empID) {
            a.push(Object.assign({}, { ...el }, { value: el.uniqueId }));
        }
        return a;
    }, [Object.assign({}, state.master.keywordValuesList.find(list => list.uniqueId === state.auth.userObject.empID), { label: `${state.auth.userObject.userName} (Self)`, value: state.auth.userObject.empID, id: parseInt(state.auth.userObject.userID) })]);

    return {
        loggedUserDetail: state.auth.userObject,
        userPref: state.auth.userPref,
        userPosInfo: state.auth.userPosInfo,
        loading: state.master.loading || state.keyword.loading,
        error: state.master.error || state.keyword.error,
        containerData: state.master.containerData,
        tableLists: state.master.requestAttributeData,
        subordinatesListData: subordinatesList,
        keywordValuesList,
        AttendanceType,
        metaData: Object.assign({}, {
            Shift: state.keyword.Shift,
            'Employees': emplist,
            'Requested For': subordinatesList,
            'Employee Id': emplist,
            'Attendance Type': AttendanceType,
        })
    }
}


const mapDispatchToProps = dispatch => {
    return {
        getContainerData: (process_Id) => dispatch(actions.getContainerData(process_Id)),
        getMasterKeywordList: (keyword) => dispatch(actions.getMasterKeywordList(keyword)),
        fetchSubordinatesLists: (empId, compId) => dispatch(actions.fetchSubordinatesLists(empId, compId)),
        getKeywordValues: (value) => dispatch(actions.getKeywordValues(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
        getRequestAttributeData: (id) => dispatch(actions.getRequestAttributeData(id)),
        clearCacheStorage: (type, data) => dispatch(actions.clearCacheStorage(type, data))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(TimeBooking);